/**
 * Star Rating Component
 * Allows users to rate urgency/priority from 1-5 stars
 */

import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/colors';
import { URGENCY_LABELS } from '@/types/feedback.types';

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  disabled?: boolean;
}

export const StarRating: React.FC<StarRatingProps> = ({ rating, onRatingChange, disabled }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>How urgent is this?</Text>
      <View style={styles.starsContainer}>
        {[1, 2, 3, 4, 5].map(star => (
          <TouchableOpacity
            key={star}
            onPress={() => !disabled && onRatingChange(star)}
            disabled={disabled}
            style={styles.starButton}
            activeOpacity={0.7}
          >
            <Ionicons
              name={star <= rating ? 'star' : 'star-outline'}
              size={32}
              color={star <= rating ? Colors.accent.primary : Colors.text.tertiary}
            />
          </TouchableOpacity>
        ))}
      </View>
      <Text style={styles.ratingText}>{URGENCY_LABELS[rating as keyof typeof URGENCY_LABELS]}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.text.primary,
    marginBottom: 8,
  },
  starsContainer: {
    flexDirection: 'row',
    gap: 8,
  },
  starButton: {
    padding: 4,
  },
  ratingText: {
    fontSize: 12,
    color: Colors.text.secondary,
    marginTop: 8,
  },
});
